module.exports = __webpack_public_path__ + "static/img/何利名片PC.d592a7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/contact/何利名片PC.jpg
// module id = T3pr
// module chunks = 1